var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0254 21.4837C13.1768 21.6127 13.3733 21.6763 13.5715 21.6604C13.7698 21.6446 13.9537 21.5506 14.0827 21.3992L19.7183 14.785L20.0798 19.3241C20.0877 19.4224 20.1148 19.5182 20.1597 19.606C20.2046 19.6938 20.2663 19.7719 20.3414 19.8359C20.4164 19.8998 20.5034 19.9484 20.5972 19.9787C20.691 20.0091 20.7899 20.0207 20.8882 20.0128C20.9865 20.005 21.0823 19.9778 21.1701 19.933C21.2579 19.8881 21.336 19.8264 21.4 19.7513C21.4639 19.6762 21.5125 19.5893 21.5429 19.4955C21.5732 19.4017 21.5848 19.3028 21.577 19.2045L21.0702 12.8607C21.0624 12.7624 21.0354 12.6665 20.9905 12.5786C20.9457 12.4908 20.884 12.4126 20.8089 12.3486C20.7338 12.2846 20.6468 12.2361 20.5529 12.2058C20.4591 12.1755 20.3601 12.164 20.2618 12.172L13.918 12.6788C13.7195 12.6946 13.5354 12.7887 13.4062 12.9403C13.2771 13.0919 13.2134 13.2886 13.2293 13.4871C13.2451 13.6856 13.3392 13.8697 13.4908 13.9989C13.6424 14.1281 13.8391 14.1917 14.0377 14.1759L18.5765 13.8122L12.9409 20.4264C12.8119 20.5778 12.7484 20.7743 12.7642 20.9725C12.78 21.1708 12.874 21.3547 13.0254 21.4837Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLink);
export default __webpack_public_path__ + "static/media/arrowLink.d05364afd54000292c8b7f86bb2248f9.svg";
export { ForwardRef as ReactComponent };